import React from "react";
import { Card } from "antd";
import { CheckCard } from "@ant-design/pro-components";
import coreFunctions from "src/common/utils/coreFunctions";

interface KPIWidgetProps {
  title: string;
  value: number;
  prefix?: string;
  icon?: string;
  icon_color?: string;
}

const KPIWidget: React.FC<KPIWidgetProps> = ({
  title,
  value,
  prefix,
  icon_color,
  icon,
}) => (
  <Card style={{ width: "100%" }}>
    <CheckCard
      avatar={coreFunctions.renderIcon(icon, {
        style: { fontSize: "35px", color: icon_color ? icon_color : "#000" },
      })}
      title={title}
      style={{
        width: "100%",
        marginTop: coreFunctions.isMobileDevice() ? -15 : 0,
      }}
      description={(prefix || "") + value}
    />
  </Card>
);

export default KPIWidget;
